/**
 * @desc  SendNoteService class.
 * @ngInject
 */
export default class SendNoteService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $rootScope, $q, $log, $http
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;
  }

  add(data) {
    return this.$http({
      method: 'POST',
      url: '/SCR/sendNote',
      data
    }).then(result => result, err => this.$q.reject(err));
  }
}
